var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-config',{attrs:{"values":_vm.getAccounts,"displayText":"fname","onSaveHandler":_vm.onSave,"onDeleteHandler":_vm.onDelete,"entityName":"Account"},scopedSlots:_vm._u([{key:"entryForm",fn:function(ref){
var selectedItem = ref.selectedItem;
var onSaveItem = ref.onSaveItem;
var onDeleteItem = ref.onDeleteItem;
return [_c('EntryForm',{attrs:{"model":_vm.dataModel,"data":selectedItem,"mode":selectedItem ? 'viewEdit' : 'new'},on:{"onSave":onSaveItem,"onDelete":onDeleteItem}})]}},{key:"itemListing",fn:function(ref){
var onItemSelected = ref.onItemSelected;
var values = ref.values;
return [_c('item-list-tree',{key:"uuid",attrs:{"items":values,"text":"name","parent":"parent"},on:{"onClick":onItemSelected}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }